import { useEffect, useRef } from "react";
import { request } from "utils/request";
import { REACT_APP_API_URL } from "utils/environmentVariables";
import { trackEvent } from "utils/trackingFunctions";

const useTrackActiveTimeInComponent = () => {
  const startTime = useRef(Date.now());

  const resetStartTime = () => {
    startTime.current = Date.now();
  };

  const onBlur = () => {
    const timeSpentInSeconds = (Date.now() - startTime.current) / 1000;
    if (timeSpentInSeconds < 1) return;
    trackEvent("Time Spent", { timeSpentInSeconds, trackingTimeSpentVersion: 2 });
  };

  // beforeunload needs keepalive so the request completes even as the page unloads
  const onBeforeUnload = () => {
    const timeSpentInSeconds = (Date.now() - startTime.current) / 1000;
    if (timeSpentInSeconds < 1) return;
    request(`${REACT_APP_API_URL}/talentInsights/trackEvent`, {
      method: "POST",
      body: JSON.stringify({
        eventName: "Develop By Criteria - Time Spent",
        properties: {
          isPostHire: true,
          eventName: "Time Spent",
          timeSpentInSeconds,
          trackingTimeSpentVersion: 2,
        },
      }),
      keepalive: true,
    });
  };

  useEffect(() => {
    window.addEventListener("focus", resetStartTime);
    window.addEventListener("blur", onBlur);
    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("focus", resetStartTime);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  return null;
};

export default useTrackActiveTimeInComponent;
